<template>

  <div class="elements-container elements-container_under">

    <transition name="fade-el">

      <div v-show="state === 'start' || state === 'final'" class="start-el blot"></div>

    </transition>

    <transition name="fade-el">

      <div v-show="state === 'test'" class="cards"></div>

    </transition>

    <transition name="long-card_top">

      <div v-show="state === 'start' || state === 'final'" class="start-el long-card long-card_top"></div>

    </transition>

    <transition name="long-card_bot">

      <div v-show="state === 'start' || state === 'final'" class="start-el long-card long-card_bot"></div>

    </transition>

    <transition name="fade-el">

      <div v-show="state === 'final'" class="start-el start-star start-star_empty"></div>

    </transition>

    <transition name="fade-el">

      <div v-show="state === 'final'" class="start-el start-star start-star"></div>

    </transition>


  </div>


</template>

<script>

export default {

  name: 'ElementsContainerUnder',

  props: ['state']

}

</script>

<style lang="sass" scoped>

.start-el
  position: absolute

.elements-container
  position: absolute
  width: 100%
  height: 100%
  overflow: hidden

  display: flex
  flex-direction: column
  justify-content: center
  align-items: center

.cards
  position: absolute
  width: 824.23px
  height: 851.96px
  background-image: url(../assets/img/cards.svg)

.blot
  background-image: url(../assets/img/blot.svg)
  width: 143.04px
  height: 142.49px
  left: calc(50% + 250px)
  top: calc(50% - 44px)
  transform: rotateZ(10deg)

.start-star
  width: 195px
  height: 195px
  background-image: url(../assets/img/star_filled.svg)
  z-index: 10
  left: calc(50% - 294px)
  top: calc(50% - 280px)

  &_empty
    background-image: url(../assets/img/star.svg)
    left: calc(50% + 124px)
    top: calc(50%)

.long-card
  position: absolute

  &_top
    top: calc(50% - 335px)
    left: calc(50% - 305px)
    width: 488px
    height: 545px
    background-image: url(../assets/img/card_top.svg)

  &_bot
    bottom: calc(50% - 410px)
    left: calc(50% - 263px)
    width: 593px
    height: 541px
    background-image: url(../assets/img/card_bot.svg)

  .start-star
    width: 195px
    height: 195px
    background-image: url(../assets/img/star.svg)
    z-index: 10

@media (max-width: 420px)

  .start-star
    width: 35vw
    height: 35vw
    left: calc(50% - 60vw)
    top: calc(50% - 58vw)

    &_empty
      left: calc(50% + 30vw)
      top: calc(50% + 8vw)

  .blot
    width: 26vw
    height: 26vw
    margin-right: -95%
    margin-top: 7%

  .long-card
    position: absolute

    &_top
      top: calc(50% - 82vw)
      left: calc(50% - 60vw)
      width: 90vw
      height: 110vw
      background-image: url(../assets/img/card_top.svg)

    &_bot
      top: calc(50% - 14vw)
      left: calc(50% - 43vw)
      width: 100vw
      height: 92vw
      background-image: url(../assets/img/card_bot.svg)

  .cards
    width: 102vh
    height: 106vh
    margin-top: 10vh
</style>
